<rx-intuitive-teeth-orchestrator-layout>
	<rx-intuitive-teeth-diagram
		rx-intuitive-teeth-diagram-diagram
		[upperJaw]="(upperJaw$ | async) ?? []"
		[lowerJaw]="(lowerJaw$ | async) ?? []"
		(toothClicked)="onToothClicked($event)"
		(resetSelectedRequested)="onResetSelectedRequested()"
	/>

	<div rx-intuitive-teeth-diagram-banner>
		<rx-intuitive-bridge-banner
			*ngIf="showGuidanceBanner$ | async"
			(closeEvent)="onBannerClosed($event)"
		></rx-intuitive-bridge-banner>
		<tlk-banner type="error" *ngIf="validationErrorSummary$ | async as errorKey">
			<div tlkBannerBody class="rx-intuitive-bridge-error-banner__message">
				{{ errorKey | translate }}
			</div>
		</tlk-banner>
	</div>

	<rx-intuitive-bridge-indication-buttons
		rx-intuitive-teeth-diagram-buttons
		[indicationIds]="(displayedIndications$ | async) ?? []"
		[enabledIndicationIds]="(enabledIndications$ | async) ?? []"
		[selectedIndicationIds]="(selectedTeethIndicationIds$ | async) ?? []"
		[disabled]="(indicationsDisabled$ | async) ?? true"
		[asLabel]="(indicationButtonsAsLabel$ | async) ?? false"
		[canRemove]="(canRemoveSelectedTooth$ | async) ?? false"
		(indicationSelected)="onIndicationSelected($event)"
		(removeFromBridge)="onRemoveToothFromBridge()"
	/>

	<div rx-intuitive-teeth-diagram-panel>
		<rx-intuitive-tooth-editor-bridge-container />
	</div>

	<rx-intuitive-bridge-footer-container rx-intuitive-teeth-diagram-footer />

</rx-intuitive-teeth-orchestrator-layout>
